import React from "react";
import { Badge } from "@mantine/core";
import css from "./Scheduler.module.css";
import { entryMeta, fmtRange, hrsBetween, STATUS_BADGE, CAT_COLOR } from "./scheduleUtils";

// Floating hover card that follows the cursor (see SchedulerAdmin/calendars).
export default function ShiftPopup({ shift, x, y }) {
  if (!shift) return null;
  const meta = entryMeta(shift);
  // Colour by kind — same rule as the calendar cards: appointments green,
  // shifts (client or facility) purple, open amber.
  const colorCat = meta.cat === "open" ? "open" : meta.appt ? "facility" : "client";
  const color = CAT_COLOR[colorCat] || CAT_COLOR.client;
  const badge = STATUS_BADGE[shift.status] || STATUS_BADGE.scheduled;
  const dur = hrsBetween(shift.startMin, shift.endMin);

  // keep inside viewport
  const w = 260;
  const left = x + w + 16 > window.innerWidth ? Math.max(8, x - w - 14) : x + 14;
  const top = Math.min(y + 14, window.innerHeight - 180);

  return (
    <div className={css.popup} style={{ left, top }}>
      <div className={css.popHead} style={{ background: color.soft }}>
        <span className={css.popPill} style={{ color: color.ink }}>{meta.pill}</span>
        <Badge size="sm" color={badge.color} variant="light">{badge.label}</Badge>
      </div>
      <div className={css.popBody}>
        <div className={css.popTitle}>{meta.title}</div>
        {meta.facility ? <div className={css.popRow}><b>Facility</b><span>{meta.facility}</span></div> : null}
        {meta.clientName ? <div className={css.popRow}><b>Client</b><span>{meta.clientName}</span></div> : null}
        {shift.service ? <div className={css.popRow}><b>Service</b><span>{shift.service}</span></div> : null}
        <div className={css.popRow}><b>Time</b><span>{shift.allDay ? "All day" : `${fmtRange(shift.startMin, shift.endMin)} · ${dur.toFixed(1)}h`}</span></div>
      </div>
    </div>
  );
}
